import { Button, Grid, Tooltip } from 'material-ui';
import LeftArrowIcon from 'material-ui-icons/ArrowBack';
import RightArrowIcon from 'material-ui-icons/ArrowForward';
import RemoveIcon from 'material-ui-icons/Close';
import SaveIcon from 'material-ui-icons/Save';
import EventIcon from 'material-ui-icons/Event';
import ScheduleIcon from 'material-ui-icons/Schedule';
import { DatePicker, TimePicker } from 'material-ui-pickers';
import { MenuItem } from 'material-ui/Menu/index';
import { withStyles } from 'material-ui/styles/index'; // only needs to be imported once
import TextField from 'material-ui/TextField/TextField';
import React from 'react';
import { translate } from 'react-i18next';
import { isEdge } from '../../../services/browserDetector';
import { deleteFlight } from './flightServices';
import { addFlight } from '../../Reservations/reservationsServices';
import i18n from '../../../services/i18n.js';
import moment from 'moment';
import swal from 'sweetalert';


const styles = theme => ({
    clientRowTitle: {
        fontSize: '14px',
        fontWeight: 600,
        paddingLeft: '20px !important',
    },
    clientRowValue: {
        fontSize: '14px',
        fontWeight: 300,
        paddingLeft: '20px'
    },
    expandIcon: {
        color: theme.palette.primary.main
    },
    bookingTitle: {
        color: theme.palette.primary.main,
        padding: '20px 0 20px 25px',
        fontWeight: 'bold',
        fontSize: '1.2rem'
    },
    bookingSubtitle: {
        color: theme.palette.primary.main,
        padding: '20px 0 5px 25px',
        fontWeight: 'normal',
        fontSize: '1rem'
    },
    paperFrame: {
        margin: '40px 0px'
    },
    coloredIcon: {
        color: theme.palette.icon.main + '!important',
        marginRight: '-24px'
    },
    coloredIconIE: {
        color: theme.palette.icon.main + '!important',
        marginTop: '-20px',
        paddingBottom: '5px'
    },
    disableColoredIcon: {
        marginRight: '-24px'
    },
    disableColoredIconIE: {
        marginTop: '-20px',
        paddingBottom: '5px'
    }
});


class FlightComponent extends React.Component {
    constructor(props) {
        super(props);
        let flight = props.flight ? props.flight : this.getDefaultFlight();
        flight.departureDate = moment(flight.departureDate);
        flight.arrivalDate = moment(flight.arrivalDate);
        this.state = {
            flight: flight,
            readOnly: flight.flightNumber !== '',
            flightError: flight.flightNumber === ''
        };

    }

    isReadOnlyMode(flight) {
        return flight.code !== '';
    }

    async handleSaveFlight() {
        if (this.state.flightError) {
            alert(this.props.t('CONFIRM_BOOKING.PLEASE_COMPLETE_FLIGHT_DATA'));
            return;
        }

        const result = await addFlight(this.props.reservationId, this.state.flight);
        if (result.errorCode && result.errorCode !== 200) {
            const message = result.message.substring(result.message.indexOf(':') + 1).trim();
            alert(i18n.t('BOOKING_DETAIL.DELETE_FLIGHT_ERROR') + '\n' + message);
        }
        this.setState({ readOnly: true, flightError: false });
    }

    async handleDeleteFlight(flight) {
        let response = await swal({
            text: i18n.t('BOOKING_DETAIL.CONFIRM_DELETE_FLIGHT'),
            icon: 'warning',
            buttons: true,
            dangerMode: true,
        });
        if (response) {
            const result = await deleteFlight(flight.id);
            if (result.errorCode && result.errorCode !== 200) {
                const message = result.message.substring(result.message.indexOf(':') + 1).trim();
                alert(i18n.t('BOOKING_DETAIL.DELETE_FLIGHT_ERROR') + '\n' + message);
            }
            else {
                let newFlight = this.getDefaultFlight();
                this.setState({ flight: newFlight, readOnly: false, flightError: this.validateFlight(newFlight) });
            }
        }
    }

    getDefaultFlight() {
        const today = this.props.minPossibleDeparture;
        let newFlight = {
            id: Math.floor(Math.random() * Math.floor(10)),
            flightNumber: '',
            departureDate: moment(today),
            arrivalDate: moment(today).add(1, 'days').toDate(),
            fromAirportCode: '',
            toAirportCode: ''
        };
        return newFlight;
    }

    handlePropertyChange(propertyName, value) {
        let flightData = this.state.flight;
        flightData[propertyName] = value;

        let runValidator = () => {};
        const validateAirports = () => {
            const { fromAirportCode, toAirportCode } = flightData;
            if ( fromAirportCode !== '' && toAirportCode !== '' && fromAirportCode === toAirportCode ) {
                // alert('Los aeropuertos de ida y vuelta son los mismos');
                alert(i18n.t('BOOKING_DETAIL.EQUALS_AIRPORTS'));
                flightData[propertyName] = '';
            }
        };
        const validateDates = () => {
            value = moment(value).format('YYYY-MM-DDTHH:mm:ss');
            runValidator = this.handleDateDepartureArrive.bind(this, propertyName);
        };
        const validations = {
            fromAirportCode: validateAirports,
            toAirportCode: validateAirports,
            departureDate: validateDates,
            arrivalDate: validateDates
        };

        const fnValidations = validations[propertyName];
        
        fnValidations && fnValidations();

        const valid = this.validateFlight(flightData);
        this.setState({
            flight: flightData,
            flightError: valid
        });

        runValidator();

        if (this.props.onChange) {
            this.props.onChange(this.state.flight);
        }
    }

    handleDateDepartureArrive(prop){
        const departureDate = moment(this.state.flight.departureDate);
        const arrivalDate = moment(this.state.flight.arrivalDate);

        // Si la fecha de salida es mayor a la de llegada
        if (departureDate.isAfter(arrivalDate)) {
            let flightData = this.state.flight;
            const { t } = this.props;
            flightData['arrivalDate'] = departureDate;
            this.setState({
                flight: flightData,
            });
            // Solo levantar el mensaje cuando se esté modificando la fecha de llegada
            if (prop === 'arrivalDate') {
                alert(t('BOOKING_DETAIL.ARRIVE_GREATHER_THAN_DEPARTURE'));
            }
        }

        this.props.onArrivalChange(arrivalDate);

    }


    validateFlight(flight) {
        return flight && Object.entries(flight).filter(e => e[1] === '').length > 0;
    }

    render() {

        const { classes, t, minPossibleDeparture } = this.props;
        let { airports } = this.props;
        if (!Array.isArray(airports)) {
            airports = [];
        }
        let { flight, flightError, readOnly } = this.state;
        const minDateForArrivalDate = moment(flight.departureDate || new Date()).toDate();
        return (
            <Grid container xs={12} className="formContainer">
                <Grid item>
                    <TextField
                        fullWidth
                        disabled={readOnly}
                        className={readOnly
                            ? 'disable'
                            : ''}
                        label={t('BOOKING_DETAIL.FLIGHT_NUMBER')}
                        InputLabelProps={{ shrink: true }}
                        placeholder={t('BOOKING_DETAIL.FLIGHT_NUMBER')}
                        required={true}
                        value={flight.flightNumber}
                        error={flightError}
                        onChange={event => {
                            this.handlePropertyChange('flightNumber', String(event.target.value));
                        }}
                    />
                </Grid>
                <Grid container item xs={6} wrap="nowrap">
                    <Grid item xs={3}>
                        <DatePicker
                            value={flight.departureDate}
                            minDate={minPossibleDeparture}
                            disabled={readOnly}
                            className={readOnly
                                ? 'datePickerResults disable'
                                : 'datePickerResults'}
                            error={flightError}
                            onChange={value => {
                                this.handlePropertyChange('departureDate', value);
                            }}
                            label={t('BOOKING_DETAIL.FLIGHT_DEPARTURE_DATE')}
                            keyboard
                            required={true}
                            format={'DD/MM/YYYY'}
                            autoOk
                            leftArrowIcon={<LeftArrowIcon />}
                            rightArrowIcon={<RightArrowIcon />}
                            InputLabelProps={{
                                className: classes.inputLabel,
                            }}
                            disablePast
                            keyboardIcon={
                                <EventIcon
                                    className={
                                        readOnly ?
                                            isEdge() ? classes.disableColoredIconIE :
                                                classes.disableColoredIcon
                                            : isEdge() ? classes.coloredIconIE :
                                                classes.coloredIcon
                                    }
                                />
                            }
                            animateYearScrolling={false}
                            minDateMessage={t('HOME.DATE_VALIDATION')}
                            invalidDateMessage={t('HOME.INVALID_FORMAT')}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TimePicker
                            label={t('COMMON.HOUR')}
                            disabled={readOnly}
                            className={readOnly ? 'disable' : ''}
                            value={flight.departureDate}
                            error={flightError}
                            margin="normal"
                            onChange={value => {
                                this.handlePropertyChange('departureDate', value);
                            }}
                            keyboardIcon={
                                <ScheduleIcon />
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <DatePicker
                            value={flight.arrivalDate}
                            minDate={minDateForArrivalDate}
                            disabled={readOnly}
                            className={readOnly ? 'datePickerResults disable' : 'datePickerResults' }
                            error={flightError}
                            onChange={value => {
                                this.handlePropertyChange('arrivalDate', value);
                            }}
                            label={t('BOOKING_DETAIL.FLIGHT_ARRIVAL_DATE')}
                            keyboard
                            required={true}
                            format={'DD/MM/YYYY'}
                            autoOk
                            leftArrowIcon={<LeftArrowIcon />}
                            rightArrowIcon={<RightArrowIcon />}
                            InputLabelProps={{
                                className: classes.inputLabel,
                            }}
                            disablePast
                            keyboardIcon={
                                <EventIcon
                                    className={
                                        readOnly ?
                                            isEdge() ? classes.disableColoredIconIE :
                                                classes.disableColoredIcon
                                            : isEdge() ? classes.coloredIconIE :
                                                classes.coloredIcon
                                    }
                                />
                            }
                            animateYearScrolling={false}
                            minDateMessage={t('HOME.DATE_VALIDATE_ARRIVE_BEFORE_DEPARTURE')}
                            invalidDateMessage={t('HOME.INVALID_FORMAT')}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TimePicker
                            label={t('COMMON.HOUR')}
                            disabled={readOnly}
                            className={readOnly
                                ? 'disable'
                                : ''}
                            value={flight.arrivalDate}
                            error={flightError}
                            margin="normal"
                            onChange={value => {
                                this.handlePropertyChange('arrivalDate', value);
                            }}
                            keyboardIcon={
                                <ScheduleIcon />
                            }
                        />
                    </Grid>
                </Grid>
                <Grid container item xs={4} wrap="nowrap">
                    <Grid item xs={6}>
                        <TextField
                            select
                            fullWidth
                            error={flightError}
                            disabled={readOnly}
                            className={readOnly
                                ? 'disable'
                                : ''}
                            label={t('BOOKING_DETAIL.FLIGHT_FROM_AIRPORT')}
                            value={parseInt(flight.fromAirportCode, 10)}
                            required={true}
                            onChange={event => {
                                this.handlePropertyChange('fromAirportCode', String(event.target.value));
                            }}
                            SelectProps={{ MenuProps: { className: classes.menu } }}
                            InputLabelProps={{
                                className: classes.inputLabel,
                            }}
                            InputProps={{
                                classes: {
                                    input: classes.disabledTextFieldInput,
                                },
                            }}
                        >
                            {airports.map((airport, ix) => (
                                <MenuItem key={ix} value={Number.parseInt(airport.code)}>
                                    {airport.name}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            select
                            disabled={readOnly}
                            className={readOnly
                                ? 'disable'
                                : ''}
                            error={flightError}
                            fullWidth
                            label={t('BOOKING_DETAIL.FLIGHT_TO_AIRPORT')}
                            value={parseInt(flight.toAirportCode, 10)}
                            required={true}
                            onChange={event => {
                                this.handlePropertyChange('toAirportCode', String(event.target.value));
                            }}
                            SelectProps={{ MenuProps: { className: classes.menu } }}
                            InputLabelProps={{
                                className: classes.inputLabel,
                            }}
                            InputProps={{
                                classes: {
                                    input: classes.disabledTextFieldInput,
                                },
                            }}
                        >
                            {airports.map((airport, ix) => (
                                <MenuItem key={ix} value={Number.parseInt(airport.code)}>
                                    {airport.name}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                </Grid>
                {
                    this.props.showButtons ?
                        <Grid container item xs={12} wrap="nowrap">
                            <Button
                                variant="flat"
                                mini
                                color="primary"
                                disabled={!readOnly}
                                onClick={event => {
                                    this.handleDeleteFlight(flight);
                                }}>
                                <Tooltip title={t('BOOKING_DETAIL.DELETE_FLIGHT')} enterDelay={200}>
                                    <RemoveIcon />
                                </Tooltip>
                            </Button>
                            <Button
                                mini
                                variant="flat"
                                color="primary"
                                disabled={readOnly}
                                onClick={event => {
                                    this.handleSaveFlight();
                                }}>
                                <Tooltip title={t('BOOKING_DETAIL.SAVE_FLIGHT')} enterDelay={200}>
                                    <SaveIcon />
                                </Tooltip>
                            </Button>
                        </Grid>
                        : ''
                }
            </Grid>
        );

    }
}

FlightComponent.defaultProps = {
    departureValidationMessage: 'HOME.DATE_VALIDATION_DEPARTURE'
};

export default translate('translations')(withStyles(styles)(FlightComponent));



// WEBPACK FOOTER //
// ./src/components/Reservation/Flight/FlightComponent.js